const getColorByStatus = (status) => {
  switch (status.toLowerCase()) {
    case 'pending':
      return 'processing';
    case 'expired':
      return 'default';
    case 'accepted':
      return 'success';
    default:
      return 'default';
  }
};

export default { getColorByStatus };
